// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"e_Fu","scoreNumber":"e_Gu","scoreStars":"e_Hu","badge":"e_Iu","badgeImage":"e_Ju"};